export enum WebSocketClientAction {
  JOIN_REGATTA = 'joinRegatta',
  JOIN_BLOG = 'joinBlog',
  REQUEST_UPDATE = 'requestUpdate',
  SEND_MESSAGE = 'sendMessage',
}

export interface WebSocketConnectionState {
  status: 'initial' | 'connecting' | 'connected' | 'error' | 'closed' | 'reconnecting';
  error?: string;
  attempts?: number;
}
